import apiFetch from '../apiFetch'

export default function ({ dosisReales, volumenTipoDosis, nombre, nombreRaza, fechaExtraccion, volumenDiluyente, idPool }) {
    return apiFetch({
        endPoint: `Pool/imprimirBagmatic?idPool=${idPool}&dosisReales=${dosisReales}&volumenTipoDosis=${volumenTipoDosis}&nombre=${nombre}&nombreRaza=${nombreRaza}&fechaExtraccion=${fechaExtraccion}&volumenDiluyente=${volumenDiluyente}`,
        method: 'GET', body: null, token: null
    })
}
